import React from 'react'
import { Box,Text,Image,Container,Center, Heading,VStack,Select } from '@chakra-ui/react'
import Fotter from './Fotter'
const About = () => {
  return (
    <div>
      <Container maxW={"1240px"} paddingLeft={"30px"} backgroundColor={"#383838"}
      color={"white"} width={"100%"}>
        
        
          <Text fontSize={"20px"} fontFamily={"Verdana, Arial, sans-serif"}>
        About Zoomcar
        </Text>

        <Text lineHeight={"25px"} marginTop={"15px"} fontFamily={"Verdana, Arial, sans-serif"} >
Zoomcar is India’s largest marketplace for cars on rent. From short road trips to quick in-city drives for groceries, supply pick-up, food runs, we have the cheapest car rental options for all your needs! A hatchback for daily commute, a sedan for short trips, SUV for hills or a luxury car for a surprise.
</Text>

<Text lineHeight={"25px"} marginTop={"15px"} fontFamily={"Verdana, Arial, sans-serif"}>
With Zoomcar, you can experience the convenience of online booking. The cars listed on our platform come with all-India permits that include vehicle insurance. It is extremely easy to pick up the car from the host location. You can drive unlimited KMs, with 100% Free Cancellation up to 6 hours before the trip start, 0 Security Deposit, 0 Toll Charges, and 24/7 Roadside Assistance. Car rent per KM starts as low as Rs. 49/hour. From short road trips to quick in-city drives for groceries, supply pick-up, meeting friends and family, doctor visits, business trips, we have the cheapest car rental options for all your needs! A hatchback for daily commute, a sedan for short trips, SUV for hills or a luxury car for a surprise.
</Text>

<Text fontSize={"20px"} marginTop={"20px"} fontFamily={"Verdana, Arial, sans-serif"}>
Why Zoomcar?
</Text>

<Text fontSize={"18px"} marginTop={"15px"} fontFamily={"Verdana, Arial, sans-serif"}>
Unlimited KMs
</Text>

<Text lineHeight={"25px"} marginTop={"15px"} fontFamily={"Verdana, Arial, sans-serif"}>
You must never stop exploring! That’s why you get unlimited KMs with every booking!
</Text>

<Text fontSize={"18px"} marginTop={"15px"} fontFamily={"Verdana, Arial, sans-serif"}>
No Paperwork
</Text>

<Text lineHeight={"25px"} marginTop={"15px"} fontFamily={"Verdana, Arial, sans-serif"}>
Rent a car & start traveling with zero paperwork requirements! All you need in your driver’s license, national ID & a live selfie!
</Text>

<Text fontSize={"18px"} marginTop={"15px"} fontFamily={"Verdana, Arial, sans-serif"}>
Short-Duration
</Text>

<Text lineHeight={"25px"} marginTop={"15px"} fontFamily={"Verdana, Arial, sans-serif"}>
Why pay for a full day when you need the car for only 8 hours? Zoomcar lets you rent a car for as low as 8 hours only!
</Text>

<Text fontSize={"18px"} marginTop={"15px"} fontFamily={"Verdana, Arial, sans-serif"}>
Long-Duration
</Text>

<Text lineHeight={"25px"} marginTop={"15px"} fontFamily={"Verdana, Arial, sans-serif"}>
Don’t put a limit to your travel plans - our long-duration bookings are here for you. Remember, the longer you book for, the more you save!
</Text>

<Text fontSize={"18px"} marginTop={"15px"} fontFamily={"Verdana, Arial, sans-serif"}>
Keyless Access
</Text>

<Text lineHeight={"25px"} marginTop={"15px"} fontFamily={"Verdana, Arial, sans-serif"}>
No need to meet the Hosts during the beginning & end of any booking! The Zoommcar smart-app allows you to lock & unlock the car directly through the app!
</Text>

<Text lineHeight={"25px"} marginTop={"15px"} fontFamily={"Verdana, Arial, sans-serif"}>
Zoomcar gives you the freedom of self-drive! With budget car rental solutions, Zoomcar offers the best offers, the cheapest prices and a wide range of cars to choose from. Get unlimited KMs, Free Cancellation, 0 Security Deposit, 0 Toll Charges, and 24/7 Roadside Assistance. Car rent per KM starts as low as Rs. 49/hour.
</Text>

<Text fontSize={"20px"} marginTop={"20px"} fontFamily={"Verdana, Arial, sans-serif"}>
Flying Soon? We’ll Be There!
</Text>

<Text lineHeight={"25px"} marginTop={"15px"} fontFamily={"Verdana, Arial, sans-serif"}>
No waiting for cabs or fighting the fares anymore - Zoomcar provides Airport trip services. The airport car rent service allows you to book a car from the airport & drive it home. Arrive in any city worry-free! We assure you unbeatable prices!
</Text>

<Text lineHeight={"25px"} marginTop={"15px"} fontFamily={"Verdana, Arial, sans-serif"}>
Car Rental in Bangalore Airport | Car Rental in Hyderabad Airport | Car Rental in Mumbai Airport | Car Rental in Delhi-NCR Airport | Car Rental in Chennai Airport | Car Rental in Pune Airport | Car Rental in Kolkata Airport | Car Rental in Ahmedabad Airport | Car Rental in Bhubaneswar Airport | Car Rental in Chandigarh Airport | Car Rental in Coimbatore Airport | Car Rental in Jaipur Airport | Car Rental in Kochi Airport | Car Rental in Mangalore Airport | Car Rental in Mysore Airport | Car Rental in Nagpur Airport | Car Rental in Surat Airport | Car Rental in Tirupati Airport | Car Rental in Trivandrum Airport | Car Rental in Vadodara Airport | Car Rental in Vijayawada Airport
</Text>

<Text fontSize={"20px"} marginTop={"20px"} fontFamily={"Verdana, Arial, sans-serif"}>
We’ve Got A Car For All Your Needs:
</Text>

<Text lineHeight={"25px"} marginTop={"15px"} fontFamily={"Verdana, Arial, sans-serif"}>
From long durations to short distances, book a Zoomcar for all your needs: Rent SUV | Rent Hatchback | Rent Sedan | Rent EV
</Text>

<Text fontSize={"20px"} marginTop={"20px"} fontFamily={"Verdana, Arial, sans-serif"}>
Anywhere, Anytime:
</Text>

<Text lineHeight={"25px"} marginTop={"15px"} fontFamily={"Verdana, Arial, sans-serif"}>
Cars to rent in Bangalore | Cars to rent in Mumbai | Cars to rent in Delhi NCR |Cars to rent in Chennai |Cars to rent in Pune |Cars to rent in Hyderabad |Cars to rent in Chandigarh |Cars to rent in Kolkata |Cars to rent in Ahmedabad |Cars to rent in Coimbatore |Cars to rent in Indore |Cars to rent in Jaipur Cars to rent in Vizag |Cars to rent in Goa |Cars to rent in Nagpur |Cars to rent in Kochi |Cars to rent in Vijayawada |Cars to rent in Siliguri |Cars to rent in Surat |Cars to rent in Bhopal |Cars to rent in Bhubaneswar | Cars to rent in Lucknow |Cars to rent in Guwahati |Cars to rent in Vadodara |Cars to rent in Ranchi |Cars to rent in Patna | Cars to rent in Raipur | Cars to rent in Jodhpur |Cars to rent in Nashik |Cars to rent in Trichy |Cars to rent in Madurai
</Text>

<Text fontSize={"20px"} marginTop={"20px"} fontFamily={"Verdana, Arial, sans-serif"}>
Want A Specific Car? We’ve Got It All:
</Text>

<Text lineHeight={"25px"} marginTop={"15px"} fontFamily={"Verdana, Arial, sans-serif"}>
Rent Tata Nexon | Rent Honda Jazz | Rent Hyundai Creta | Rent Maruti Brezza | Rent Mahindra | Rent XUV500 | Rent Hyundai Verna | Rent Maruti Swift | Rent Toyota Innova | Rent Reanult Kwid | Rent Maruti Baleno | Rent Mahindra TUV300| Rent Maruti Swift | Rent Hyundai i20 | Rent Maruti Ertiga | Rent Volkswagen Polo | Rent Hyundai Venue | Rent Hyundai Eon | Rent Maruti S-Cross | Rent Maruti | Rent Dzire | Rent Honda Amaze | Rent Hyundai Verna | Rent Maruti Ciaz | Rent Hyundai Creta | Rent Renault Triber | Rent Maruti S-Cross | Rent Toyota Innova | Rent Mahindra TUV300 | Rent Tata Tiago | Rent Maruti Wagon R | Rent Datson Redi-Go | Rent Maruti Alto | Rent Hyundai Grand i10 | Rent Hyundai Xcent | Rent Maruti S-Presso | Rent Hyundai Santro | Rent Hyundai Verna | Rent Maruti Ignis | Rent Nissan Magnite | Rent Toyota Glanza | Rent Honda City | Rent Maruti Dzire | Rent Datson GO T | Rent Nissan Sunny | Rent Renault Kiger | Rent Hyundai Aura | Rent Renault Duster | Rent Mahindra Bolero | Rent Tata Altroz | Rent Ford EcoSport
</Text>

<Text lineHeight={"25px"} marginTop={"15px"} fontFamily={"Verdana, Arial, sans-serif"}>
If you’re looking for cars to rent near you, Zoomcar is your perfect solution! Rent cars in 3 easy steps: Pick your date & time of travel Select the vehicle of your choice from our wide range of cars Book & zoom away
</Text>

<Text fontSize={"20px"} marginTop={"20px"} fontFamily={"Verdana, Arial, sans-serif"}>
Why Book A Zoomcar?
</Text>

<Text lineHeight={"25px"} marginTop={"15px"} fontFamily={"Verdana, Arial, sans-serif"}>
Zoomcar gives you the freedom of self-drive! With the cheapest rental car solutions, Zoomcar has the best offers, cheapest prices and a wide range of cars to choose from. Get unlimited KMs, Free Cancellation, 0 Security Deposit, 0 Toll Charges, and 24/7 Roadside Assistance. Car rent per KM starts as low as Rs. 49/hour.
</Text>

<Text fontSize={"20px"} marginTop={"20px"} fontFamily={"Verdana, Arial, sans-serif"}>
How To Rent A Car Through Zoomcar?
</Text>

<Text lineHeight={"25px"} marginTop={"15px"} fontFamily={"Verdana, Arial, sans-serif"}>
If you’re looking for cars to rent near you, Zoomcar is your perfect solution! Rent cars in 3 easy steps: Pick your date & time of travel Select the vehicle of your choice from our wide range of cars Book & zoom away Rent car & get unlimited KMs, Free Cancellation, 0 Security Deposit, 0 Toll Charges, and 24/7 Roadside Assistance. Car rent per KM starts as low as Rs. 49/hour.
</Text>

<Text fontSize={"20px"} marginTop={"20px"} fontFamily={"Verdana, Arial, sans-serif"}>
Can Zoomcar Be Used For Interstate Travel?
</Text>

<Text lineHeight={"25px"} marginTop={"15px"} fontFamily={"Verdana, Arial, sans-serif"}>
Experience the ease of round trips with Zoomcar! All you have to do is enter your start & end date & time for your journey. Once you rent a car, you get unlimited KMs, Free Cancellation, 0 Security Deposit, 0 Toll Charges, and 24/7 Roadside Assistance. Car rent per KM starts as low as Rs. 49/hour.
</Text>

<Text fontSize={"20px"} marginTop={"20px"} fontFamily={"Verdana, Arial, sans-serif"}>
Can A Zoomcar Booking Be Cancelled?
</Text>

<Text lineHeight={"25px"} marginTop={"15px"} fontFamily={"Verdana, Arial, sans-serif"}>
With Zoomcar, you get free cancellation & free rescheduling up to 6 hours before the trip starts. Rent cars & get unlimited KMs, Free Cancellation, 0 Security Deposit, 0 Toll Charges, and 24/7 Roadside Assistance. Car rent per KM starts as low as Rs. 49/hour.
</Text>

<Text fontSize={"20px"} marginTop={"20px"} fontFamily={"Verdana, Arial, sans-serif"}>
How To Contact Zoomcar?
</Text>

<Text lineHeight={"25px"} marginTop={"15px"} fontFamily={"Verdana, Arial, sans-serif"}>
Zoomcar is the biggest budget car rental marketplace in India. Our executives are available to respond to your queries & solve your problems 24/7 through our customer support portal!
</Text>

<Text fontSize={"20px"} marginTop={"20px"} fontFamily={"Verdana, Arial, sans-serif"}>
How To Book A Zoomcar From The Airport?
</Text>

<Text lineHeight={"25px"} marginTop={"15px"} fontFamily={"Verdana, Arial, sans-serif"}>
No waiting for cabs or fighting the fares anymore - Zoomcar provides Airport trip services. The airport car rent service allows you to book a car from the airport & drive it home. Arrive in any city worry-free! We assure you unbeatable prices!
</Text>

<Text fontSize={"20px"} marginTop={"20px"} fontFamily={"Verdana, Arial, sans-serif"}>
What Are The Best Cars For Long Trips?
</Text>

<Text lineHeight={"25px"} marginTop={"15px"} fontFamily={"Verdana, Arial, sans-serif"}>
Rent an SUV or Sedan for maximum convenience! Zoomcar has many popular SUVs and Sedans on its platform to choose from & rent.
</Text>

<Text fontSize={"20px"} marginTop={"20px"} fontFamily={"Verdana, Arial, sans-serif"}>
What Events Can I Rent A Zoomcar For?
</Text>

<Text lineHeight={"25px"} marginTop={"15px"} fontFamily={"Verdana, Arial, sans-serif"} >
Zoomcar provides car rentals for music events, short trips within the city, trips with friends, trips with family, temple visits, long-duration trips, short-duration trips, road trips with friends and family & much more! Car rental starts as low as Rs. 49/hour.
</Text>


      </Container>
     <Fotter/>
    </div>
  )
}

export default About